<!-- このチケット商材のmax_purchaseに達していて購入画面に遷移できないことを示唆するダイアログ -->
<template>
  <ItemDialog ref="inableToBuy" image-type="alert">
    <template #content-area>
      <h2>{{ $t("Errors.reachedPurchaseLimit.title") }}</h2>
      <p class="text-center">
        {{ $t("Errors.reachedPurchaseLimit.description") }}
      </p>
    </template>
    <template #button-area>
      <ItemButton
        :label="$t('Errors.reachedPurchaseLimit.buttonLabel')"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogInableToBuy",
  setup() {
    const inableToBuy = ref(null);

    const openDialog = () => {
      inableToBuy.value.open();
    };

    const closeDialog = () => {
      inableToBuy.value.close();
    };

    return {
      inableToBuy,
      openDialog,
      closeDialog,
    };
  },
};
</script>
